import client from "../sanityClient"

export const fetchBlogs = async () => {
  try {
    const data = await client.fetch(`
      *[_type == "post"]{
        title,
        slug,
        body[] {
          ...,
          _type == "image" => {
            "url": asset->url,
            "alt": asset.altText
          }
        },
        mainImage {
          asset -> {
            _id,
            url
          },
          alt,
        },
        publishedAt,
        author-> {
          name,
          image {
            asset -> {
              url
            }
          }
        },
        categories[]-> {
          title,
          subcategories[]-> {
            title,
            description
          }
        }
      } | order(publishedAt desc)
    `)
    return data
  } catch (err) {
    console.error('Error fetching blogs:', err)
    throw new Error('Failed to fetch blog posts. Please try again later.')
  }
}

export const fetchCategories = async () => {
  try {
    const data = await client.fetch(`
            *[_type == "category"]{
                _id,
                title,
                icon,
                subcategories[]-> {
                    _id,
                    title,
                    description
                }
            }
        `)
    return data
  } catch (err) {
    console.error('Error fetching categories:', err)
    throw new Error('Failed to fetch categories. Please try again later.')
  }
}

export const debounce = (func, wait) => {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}